// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import { Table } from 'react-bootstrap';
import moment from 'moment';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { connect } from 'react-redux';
import DollarOutput from '../utils/DollarOutput';
import Sorter from '../utils/Sorting/Sorter';
import { CDT } from '../../infrastructure/constants/common';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { isMobileResolution } from '../../infrastructure/utils/common';
import PartyOrdersListMobile from './PartyOrdersList/PartyOrdersListMobile';

class ActivityOrdersList extends React.PureComponent {
  handleOnClick = event => {
    event.preventDefault();
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleOnClick } = this.props;
    handleOnClick(event.currentTarget.getAttribute('href'));
  };

  getBookingOption = order => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { options } = this.props;
    if (order.bookingOptionId) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      const option = options.find(opt => opt.id === order.bookingOptionId);
      return option ? option.title : '';
    }
    if (order.bookingOptions) {
      const ids = order.bookingOptions.map(option => option.id);
      const opt = options // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        .filter(elem => ids.includes(elem.id))
        .map(el => el.title);
      return opt.join(', ');
    }
    return '';
  };

  changeSort = event => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { changeSort } = this.props;
    event.stopPropagation();
    event.preventDefault();
    changeSort(event.currentTarget.getAttribute('name'));
  };

  getEventDate = order => `${moment(order.startDateTime)
    .tz(CDT)
    .format('MM/DD/YY hh:mm A ')}
       - ${moment(order.endDateTime).tz(CDT).format('MM/DD/YY hh:mm A z')}`;

  getOrderPlacedDate = order =>
    moment(order.created).tz(CDT).format('MM/DD/YY hh:mm A z');

  renderOrder = order => (
    <tr
      key={order.id}
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      href={`/orders/${order.id}`}
      className='listrow'
      onClick={this.handleOnClick}
    >
      <td style={{ verticalAlign: 'middle' }}>{order.bachConfirmation}</td>
      <td style={{ verticalAlign: 'middle' }}>{this.getEventDate(order)}</td>
      <td style={{ verticalAlign: 'middle' }}>
        {this.getBookingOption(order)}
      </td>
      <td style={{ verticalAlign: 'middle' }}>
        <DollarOutput value={order.totalPrice} />
      </td>
      <td style={{ verticalAlign: 'middle' }}>{order.status}</td>
      <td style={{ verticalAlign: 'middle' }}>
        {moment(order.created).tz(CDT).format('MM/DD/YY hh:mm A z')}
      </td>
    </tr>
  );

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { orders, activeSort } = this.props;
    if (isMobileResolution()) {
      return (
        <PartyOrdersListMobile
          orders={orders}
          getEventDate={this.getEventDate}
          getOrderPlacedDate={this.getOrderPlacedDate}
          onOrderClick={this.handleOnClick}
        />
      );
    }

    return (
      <div className='orderslist'>
        <Table hover>
          <thead>
            <tr>
              <th>BACH Confirmation Code</th>
              <th>Event Dates (Central Time)</th>
              <th>Booking Option</th>
              <th
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                name='totalPrice'
                className='sortColumn'
                onClick={this.changeSort}
              >
                Price <Sorter activeSort={activeSort} name='totalPrice' />
              </th>
              <th
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                name='status'
                className='sortColumn'
                onClick={this.changeSort}
              >
                Status <Sorter activeSort={activeSort} name='status' />
              </th>
              <th
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                name='created'
                className='sortColumn'
                onClick={this.changeSort}
              >
                Order Placed Date (Central Time){' '}
                <Sorter activeSort={activeSort} name='created' />
              </th>
            </tr>
          </thead>
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line react/prop-types */}
          <tbody>{orders.map(order => this.renderOrder(order))}</tbody>
        </Table>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    shopify: state.shopify.shopifyLinks,
  };
}

export default connect(mapStateToProps)(ActivityOrdersList);
